import { c as _c } from "react/compiler-runtime";
import { IssueTitleParts } from '../../../../utils/issues';
import Chip from '../../../common/base/Chip';
import Text from '../../../common/base/Text';
import { Div } from '../../../common/helpers/StyledUtils';
const IssueTitle: React.FC<{
  parts: IssueTitleParts;
  bold?: boolean;
  size?: 'l' | 'm' | 's';
}> = t0 => {
  const $ = _c(12);
  const {
    parts,
    bold,
    size: t1
  } = t0;
  const size = t1 === undefined ? "l" : t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      gap: 1,
      align: "center"
    };
    t3 = {
      overflow: "hidden"
    };
    $[0] = t2;
    $[1] = t3;
  } else {
    t2 = $[0];
    t3 = $[1];
  }
  let t4;
  if ($[2] !== bold || $[3] !== parts || $[4] !== size) {
    let t5;
    if ($[6] !== bold || $[7] !== parts.length || $[8] !== size) {
      t5 = (p, i) => {
        const is_last = i === parts.length - 1;
        if (typeof p === "string" || !("to" in p)) {
          return <Text text_wrap={false} semi={true} bold={bold} key={i} size={size} ellipsis={is_last} title={typeof p === "string" ? p : p.label}>{typeof p === "string" ? p : p.label}</Text>;
        }
        if ("to" in p && p.type === "label") {
          return <Chip key={i} label={p.label} title={p.label} to={p.to} mono={true} outline={true} m={{
            l: 1
          }} max_w={{
            px: 400
          }} />;
        }
        return <Text key={i} text_wrap={false} semi={true} dark={true} bold={bold} size={size} title={p.label}>{p.label}</Text>;
      };
      $[6] = bold;
      $[7] = parts.length;
      $[8] = size;
      $[9] = t5;
    } else {
      t5 = $[9];
    }
    t4 = parts.map(t5);
    $[2] = bold;
    $[3] = parts;
    $[4] = size;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[10] !== t4) {
    t5 = <Div flex={t2} style={t3}>{t4}</Div>;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};
export default IssueTitle;